var _rect, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNouislider = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 10,
    width: 16,
    height: 2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "2,4 2,7 4,9 6,7 6,4 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "10,4 10,7 12,9 14,7 14,4 "
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNouislider);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nouislider.9ba7109b266d2f437cd28076b82197d9.svg";